import { create } from "zustand";
import { WorkerContext, WorkerState } from "./workersContext.types";

export const INITIAL_WORKER_STATE: WorkerState = {
  workers: [],
  selectedWorker: null,
  typeWorker: 0,
  workerProfile: undefined,
  workItemsFromWorker: [],
};

export const useWorkerStore = create<WorkerContext>((set) => ({
  ...INITIAL_WORKER_STATE,
  setWorkers: (workers) => set({ workers }),
  setWorkerProfile: (workerProfile) => set({ workerProfile }),
  setTypeWorker: (typeWorker) => set({ typeWorker }),
  setSelectedWorker: (selectedWorker) => set({ selectedWorker }),
  setWorkItemsFromWorker: (workItemsFromWorker) => set({ workItemsFromWorker }),
}));
